import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TcpGraphComponent } from './tcp-graph.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ChartModule } from 'angular-highcharts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TcpGraphRoutingModule } from './tcp-graph-routing.module';



@NgModule({
  declarations: [
    TcpGraphComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ChartModule,
    ReactiveFormsModule,
    FormsModule,
    TcpGraphRoutingModule
  ],
  exports:[
    TcpGraphComponent
  ]
})
export class TcpGraphModule { }
